import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useQueryClient } from 'react-query'
import _ from 'lodash'
import { SignatureSection } from '../../../../components/generic'
import { onSubmit } from './utils'

const Signatures = (props) => {
  const {
    resident,
    carePlan,
    logs,
    carers,
    setLoadedListItem,
    preferredCarePlanName,
    item,
    category,
    informedConsentEnabled
  } = props

  const queryClient = useQueryClient()
  const [isSubmitting, setIsSubmitting] = useState(false)
  if (!resident || !carePlan) return null

  const carePlanName = `${carePlan.customName || carePlan.carePlanAdl.name}`

  const mappedLogs = logs?.map((log) => {
    if (!log.loggedBy || log.loggedBy.name) return log
    const carerId =
      typeof log.loggedBy === 'string' ? log.loggedBy : log.loggedBy.id
    const carer = _.find(carers, { id: carerId })
    return {
      ...log,
      loggedBy: carer || log.loggedBy
    }
  })
  const handleSubmit = ({ formState, onSuccess }) => {
    if (isSubmitting) return
    setIsSubmitting(true)
    onSubmit({
      formState,
      carePlan,
      resident,
      onSuccess: () => {
        onSuccess() // modal callback to reset modal state
        setIsSubmitting(false)
      },
      onError: () => {
        setIsSubmitting(false)
      },
      setLoadedListItem,
      preferredCarePlanName,
      carePlanName,
      item,
      category,
      queryClient
    })
  }

  return (
    <SignatureSection
      title={informedConsentEnabled ? 'Care plan history' : 'Signatures'}
      buttonLabel={`Sign ${preferredCarePlanName}`}
      footerLabel={carePlanName}
      confirmText={`I confirm that I have been fully informed of, and understand, the ${preferredCarePlanName}`}
      resident={resident}
      isSubmitting={isSubmitting}
      onSubmit={handleSubmit}
      logs={mappedLogs}
      helpUrl="https://support.logmycare.co.uk/en/articles/5685192-how-do-i-sign-a-care-plan"
      informedConsentEnabled={informedConsentEnabled}
    />
  )
}

Signatures.propTypes = {
  resident: PropTypes.object,
  carePlan: PropTypes.object,
  logs: PropTypes.array,
  carers: PropTypes.array,
  setLoadedListItem: PropTypes.func,
  preferredCarePlanName: PropTypes.string,
  item: PropTypes.string,
  category: PropTypes.string,
  informedConsentEnabled: PropTypes.bool
}

export default Signatures
